import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchAccountDetailsAction } from "actions/account-settings-actions";
import { SettingsInlineTabs } from "components/settings/settings-inline-tabs";
import grid from "components/grid.scss";
import styles from "components/settings/settings.scss";
import { AccountSettingsMenu } from "components/settings/account-settings-menu";

class AccountSettings extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
  }
  render() {
    return (
      <div className={ styles.container }>
        <SettingsInlineTabs currentPage="account" slug={ this.props.slug } />
        <div className={ grid.row }>
          <div className={ `${styles["grid-spacing"]} ${grid["col-md-1"]}` } />
          <div className={ `${styles["grid-spacing"]} ${grid["col-md-2"]}` }>
            <AccountSettingsMenu slug={ this.props.slug } vip={ this.props.vip } />
          </div>
          <div className={ `${styles["grid-spacing"]} ${grid["col-md-8"]}` }>
            <div className={ styles["child-container"] }>
              { this.props.children }
            </div>
          </div>
          <div className={ `${styles["grid-spacing"]} ${grid["col-md-1"]}` } />
        </div>
      </div>
    );
  }
}

AccountSettings.propTypes = {
  accountId: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  init: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  vip: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  slug: state.accountSettings.slug,
  vip: state.accountSettings.vip
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchAccountDetailsAction(accountId))
});

export const AccountSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(AccountSettings);



// WEBPACK FOOTER //
// ./src/js/containers/settings/account-settings-container.jsx